import React from "react";
import { Col, ColorPicker, Row, Space } from "antd";
import { ColumnProps } from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  { key: "1", title: "ID", dataIndex: "id" },
  { key: "2", title: "Tên thuốc", dataIndex: "tenThuocTra", align: "left" },
  { key: "3", title: "Tên viết tắt", dataIndex: "tenVietTat", align: "left" },

  { key: "4", title: "Thao tác", dataIndex: "action" },
];
const columnsLeDao: ColumnProps<any>[] = [
  { key: "1", title: "ID", dataIndex: "id" },
  {
    key: "3",
    title: "Kiểu lệ đạo",
    dataIndex: "type",
    align: "left",
    render: (v) => (v == 0 ? "Lệ đạo trên" : "Lệ đạo dưới"),
  },
  { key: "2", title: "Tên lệ đạo", dataIndex: "tenLeDao", align: "left" },

  { key: "4", title: "Thao tác", dataIndex: "action" },
];

const columnsNA: ColumnProps<any>[] = [
  { key: "1", title: "ID", dataIndex: "id" },
  {
    key: "3",
    title: "Giá trị hiển thị (in)",
    dataIndex: "value",
    align: "left",
  },
  { key: "2", title: "Tên nhãn áp", dataIndex: "tenNhanAp", align: "left" },

  { key: "4", title: "Thao tác", dataIndex: "action" },
];
export { columns, columnsLeDao, columnsNA };
